import { OpenAPI, SettingsService } from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT

export const getAllValidationRules = () =>
  SettingsService.getAllValidationRulesSettingsValidationRulesAllGet()

export const updateValidationRuleOutcome =
  SettingsService.updateValidationRuleSettingsValidationRulesIdUpdatePatch

export const getAllOpCoValidationRules = SettingsService.getAllOpcoValidationRulesSettingsOpcoValidationRulesAllGet
  
export const updateOpCoValidationRuleOutcome =
    SettingsService.updateOpcoValidationRuleSettingsOpcoValidationRulesIdUpdatePatch

export const getAllOpCoValidationConfigSettings = SettingsService.getOpcoConfigValidationSettingsGetOpcoConfigValidationGet
  
export const downloadTemplateForValidationRule = SettingsService.downloadConfigValidationRuleTemplateSettingsDownloadFromGcsGet
